import { gql } from '@apollo/client'

export const UPDATE_VERSION = gql`
mutation UpdateVersion($version: String!) {
  updateVersion(version: $version)
}
`